var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16553 2.63441C6.3155 2.78443 6.39976 2.98787 6.39976 3.20001C6.39976 3.41214 6.3155 3.61558 6.16553 3.76561L4.33113 5.60001H8.79993C10.2851 5.60001 11.7095 6.19 12.7597 7.24021C13.8099 8.29041 14.3999 9.71479 14.3999 11.2V12.8C14.3999 13.0122 14.3156 13.2157 14.1656 13.3657C14.0156 13.5157 13.8121 13.6 13.5999 13.6C13.3878 13.6 13.1843 13.5157 13.0342 13.3657C12.8842 13.2157 12.7999 13.0122 12.7999 12.8V11.2C12.7999 10.1391 12.3785 9.12172 11.6284 8.37158C10.8782 7.62143 9.86079 7.20001 8.79993 7.20001H4.33113L6.16553 9.03441C6.24193 9.1082 6.30288 9.19648 6.34481 9.29408C6.38673 9.39169 6.4088 9.49666 6.40973 9.60289C6.41065 9.70911 6.39041 9.81445 6.35018 9.91277C6.30996 10.0111 6.25056 10.1004 6.17544 10.1755C6.10033 10.2506 6.01101 10.31 5.91269 10.3503C5.81437 10.3905 5.70903 10.4107 5.60281 10.4098C5.49658 10.4089 5.39161 10.3868 5.294 10.3449C5.1964 10.303 5.10812 10.242 5.03433 10.1656L1.83433 6.96561C1.68435 6.81558 1.6001 6.61214 1.6001 6.40001C1.6001 6.18787 1.68435 5.98443 1.83433 5.83441L5.03433 2.63441C5.18435 2.48443 5.3878 2.40018 5.59993 2.40018C5.81206 2.40018 6.0155 2.48443 6.16553 2.63441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/Reply.c6eec6d64209c846cd49c6a0bb5d2133.svg";
export { ForwardRef as ReactComponent };